module.exports = __webpack_public_path__ + "img/full-09.8c22868e.png";